import { Routers } from "../routes/routes";

export const APPS = [{ subdomain: "default", app: Routers, main: true }];
